// components/RevenueTable.tsx
import React, { useMemo } from 'react';
import { useQueryRequest } from '../core/QueryRequestProvider';
import { useGetReportPnLvsTarget } from '../core/_query';
import { FormattedNumber, IntlProvider } from 'react-intl';

type Props = {
  year: number
}

const DashboardPnLvsTargetTargetCard: React.FC<Props> = ({year}) => {

  // const { state } = useQueryRequest()
  const { data: cardData } = useGetReportPnLvsTarget({'year': year})

  const data = useMemo(() => {
    return cardData?.response?.data
  }, [cardData])

  return (
        <table className="table table-bordered table-sm text-center align-middle">
          <thead className="table-light">
            <tr>
              <th className='w-125px'></th>
              <th className='w-125px'>ACTUAL YTD ({ data?.years || year})</th>
              <th className='w-125px'>TARGET {data?.years || year}</th>
              <th className='w-75px'>(+/-) %</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>REVENUE ALL</td>
              <td>
                {<IntlProvider locale='id'>
                  <FormattedNumber
                    value={
                      data?.actual?.revenue_all || 0
                    }
                  />
                </IntlProvider>
                }
              </td>
              <td>{<IntlProvider locale='id'>
                <FormattedNumber
                  value={
                    data?.target?.revenue_all_target || 0
                  }
                />
              </IntlProvider>
              }
              <br />
              <small>({<IntlProvider locale='id'>
                <FormattedNumber
                  value={
                    data?.target?.revenue_all_difference || 0
                  }
                />
              </IntlProvider>
              })
              </small>
              </td>
              <td>{data?.actual_against_target_percentage?.revenue_all || '0%'}</td>
            </tr>
            <tr>
              <td>REVENUE ALAYA</td>
              <td>
                <IntlProvider locale='id'>
                  <FormattedNumber
                    value={
                      data?.actual?.revenue_alaya || 0
                    }
                  />
                </IntlProvider>
              </td>
              <td>
                {<IntlProvider locale='id'>
                  <FormattedNumber
                    value={
                      data?.target?.revenue_alaya_target || 0
                    }
                  />
                </IntlProvider>
                }
                <br />
                <small>
                  ({<IntlProvider locale='id'>
                  <FormattedNumber
                    value={
                      data?.target?.revenue_alaya_difference || 0
                    }
                  />
                </IntlProvider>
                })
                </small>
                </td>
              <td>{data?.actual_against_target_percentage?.revenue_alaya || '0%'}</td>
            </tr>
            <tr>
              <td>COST</td>
              <td>
                {<IntlProvider locale='id'>
                  <FormattedNumber
                    value={
                      data?.actual?.costs || 0
                    }
                  />
                </IntlProvider>
                }
                {' '}
                ({data?.actual?.cost_percentage || '0%'})
              </td>
              <td>
                {<IntlProvider locale='id'>
                  <FormattedNumber
                    value={
                      data?.target?.cost_target || 0
                    }
                  />
                </IntlProvider>
                }
                {" "}
                ({data?.target?.cost_target_percentage || '0%'})
              </td>
              <td>{data?.actual_against_target_percentage?.cost}</td>
            </tr>
            <tr>
              <td>PROFIT</td>
              <td>
                {<IntlProvider locale='id'>
                  <FormattedNumber
                    value={
                      data?.actual?.profit || 0
                    }
                  />
                </IntlProvider>
                }
                {' '}
                ({data?.actual?.profit_percentage || '0%'})
              </td>
              <td>
                {<IntlProvider locale='id'>
                  <FormattedNumber
                    value={
                      data?.target?.profit_target || 0
                    }
                  />
                </IntlProvider>
                }
                {" "}
                ({data?.target?.profit_target_percentage || '0%'})
              </td>
              <td>{data?.actual_against_target_percentage?.profit || '0%'}</td>
            </tr>
          </tbody>
        </table>
  );
};

export default DashboardPnLvsTargetTargetCard;
